/* unplugin-vue-components disabled */import script from "./LastNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./LastNotification.vue?vue&type=script&lang=ts&setup=true"

import "./LastNotification.vue?vue&type=style&index=0&id=5ed2bcf7&lang=scss"

const __exports__ = script;

export default __exports__